// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Link,
    Typography
} from '@mui/material'
import { Link as RouterLink, useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../icon';
import apiUrl from '../../configs/constant';
import MsiDatagrid from '../custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

interface Props {
    mmgudangId?: number | string | null;
}

export default function Index({ mmgudangId }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    // ** State

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])
    const [loadingData, setLoadingData] = useState<boolean>(false)

    useEffect(() => {
        getData()
    }, [mmgudangId])

    const navigate = useNavigate();

    const getData = () => {
        setLoadingData(true)

        let url = apiUrl.apiUrl + '/gudang/detail-mutasi/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mmgudang_id: mmgudangId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Gagal memuat data',
                    text: error.response?.data?.message || error.message,
                    icon: 'error'
                })
            })
            .finally(() => setLoadingData(false))
    }

    const convertComponent = [
        {
            key: 'preview',
            renderCell: ({ data, value }: any) => data.wo_order_id && value ? (
                <Link
                    component={RouterLink}
                    to={`/production/work-order/detail/${data.wo_order_id}`}
                    underline='hover'
                    fontWeight={700}
                    aria-label={`Buka work order ${value}`}
                    onClick={event => event.stopPropagation()}
                >
                    {value}
                </Link>
            ) : <Typography component='span' variant='body2' color='text.secondary'>—</Typography>
        },
        {
            key: 'nama_barang',
            renderCell: ({ row }: any) => (
                <div style={{ cursor: 'pointer' }} onClick={() => {
                    const data = row.data

                    window.open(`/mm/master-barang/detail/${data.barang_id}`, '_blank')
                }}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.data.nama_barang}
                    </Typography>
                </div>
            )
        }
    ]

    const ActionButtons = ({ row, onNavigate }: {
        row: any;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 70,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onNavigate={(row: any) => {
                        if (row.tipe_mutasi == 'mmusage') {
                            window.open(`/mm/usage/detail/${row.mutasi_id}`, '_blank')
                        } else if (row.tipe_mutasi == 'mmopname') {
                            window.open(`/gudang/view-opname-new/${row.mutasi_id}?view=0`, '_blank')
                        }
                    }}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <Divider />
                <Box
                    sx={{
                        mt: 2,
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        {/* <CardHeader title='SALES ORDER' /> */}
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                    </Box>
                </Box>
                <Box>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                        spacing={5}
                    >
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ mt: 1 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData()}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
                <MsiDatagrid title="Riwayat mutasi" loading={loadingData} array={listData} hiddenColumns={['id', 'mutasi_id', 'barang_id', 'wo_order_id']} customRender={convertComponent} actions={actionData} />
            </Grid>
        </Grid>
    )
}
